// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__2jLzn","footer":"ModalError_footer__3k2uQ"};